// extracted by mini-css-extract-plugin
export default {"container":"style_container__HTnyH"};